import React from 'react';

import GenericField from './shared/GenericField';
import SelectLabelInputContainer from './select_label/SelectLabelInputContainer';
import { getIcon } from './shared/FormatHelpers';

/**
 * Select between the given selectable options. "Option" object: {string id, string name, string description, string color}.
 * @param {option} [initialValue] Field value.
 * @param {list<option>} [options] Selectable options.
 * @param {function} [handleSave] [async option=>{bool success, string message}] Save changes / return error message.
 */
const SelectLabel = ({ initialValue, options, handleSave: syncChanges }) => {
    const label = getIcon('label');
    return (
        <GenericField>
            {label}
            <SelectLabelInputContainer {...{ initialValue, options, syncChanges }} />
        </GenericField>
    );
};

export default SelectLabel;
